import { addYears, endOfYear, getMonth } from 'date-fns';
import { FormikErrors } from 'formik';
import { CONTRACT_TYPE_CLIENT } from '@sr/dto';

export interface FormValues {
  name: string;
  contractStartDate: Date;
  contractEndDate: Date;
  managerId?: number;
  attachmentFileId: number;
  status: number;
  type?: number;
  sellerLegalEntityId: number;
  sellerBankDetailsId: number;
  sellerSignerId: number;
  buyerLegalEntityId: number;
  buyerBankDetailsId: number;
  buyerSignerId: number;
  specialConditions?: string;
  unlimited: boolean;
}

const now = new Date();

export const initialValues: FormValues = {
  name: '',
  contractStartDate: now,
  contractEndDate: getMonth(now) !== 11 ? endOfYear(now) : endOfYear(addYears(now, 1)),
  managerId: undefined,
  attachmentFileId: NaN,
  status: 1,
  type: NaN,
  sellerLegalEntityId: NaN,
  sellerBankDetailsId: NaN,
  sellerSignerId: NaN,
  buyerLegalEntityId: NaN,
  buyerBankDetailsId: NaN,
  buyerSignerId: NaN,
  specialConditions: undefined,
  unlimited: false
};

export const validate = (values: FormValues) => {
  const requiredMsg = 'Поле обязательно';
  const dateRequiredMsg = 'Дата окончания обязательна для срочного договора';
  const dateRangeMsg = 'Дата окончания должна быть позже даты начала';

  const errors: FormikErrors<FormValues> = {};

  if (!values.sellerLegalEntityId) errors.sellerLegalEntityId = requiredMsg;
  if (!values.sellerBankDetailsId) errors.sellerBankDetailsId = requiredMsg;
  if (!values.sellerSignerId) errors.sellerSignerId = requiredMsg;

  if (!values.buyerLegalEntityId) errors.buyerLegalEntityId = requiredMsg;
  if (!values.buyerBankDetailsId) errors.buyerBankDetailsId = requiredMsg;
  if (!values.buyerSignerId) errors.buyerSignerId = requiredMsg;
  if (values.type === CONTRACT_TYPE_CLIENT && !values.managerId) {
    errors.managerId = requiredMsg;
  }
  
  if (values.contractStartDate && values.contractEndDate) {
    if (!values.unlimited && values.contractEndDate <= values.contractStartDate) {
      errors.contractEndDate = dateRangeMsg;
    }
  }

  if (!values.unlimited && !values.contractEndDate) {
    errors.contractEndDate = dateRequiredMsg;
  }

  if (values.unlimited && errors.contractEndDate) {
    delete errors.contractEndDate;
  }
  
  return errors;
};
